import { render, staticRenderFns } from "./storehouseManageList.vue?vue&type=template&id=fd920fe8&scoped=true"
import script from "./storehouseManageList.vue?vue&type=script&lang=js"
export * from "./storehouseManageList.vue?vue&type=script&lang=js"
import style0 from "./storehouseManageList.vue?vue&type=style&index=0&id=fd920fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd920fe8",
  null
  
)

export default component.exports